var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 22.183h-.082a1.247 1.247 0 0 1-.342-2.416 1.245 1.245 0 1 1 .425 2.416zm-.588-1.281a.589.589 0 0 0 .973.48.586.586 0 0 0-.467-1.023.59.59 0 0 0-.449.323.6.6 0 0 0-.056.22m5.927 5.875h-.062a.965.965 0 0 1-.576-1.684.963.963 0 0 1 1.347.076.964.964 0 0 1-.709 1.61zm-.308-.984a.31.31 0 0 0 .288.328.305.305 0 0 0 .321-.288.309.309 0 0 0-.583-.155.3.3 0 0 0-.03.116z",
    fill: "#5E6175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.297 41.453H6.64v-.022h.656zm0-1.116H6.64v-.656h.656zm0-1.75H6.64v-.643l.656-.025v.668m-.885-1.575a2.5 2.5 0 0 0-.306-.49l.512-.41q.227.289.384.62zm-1.069-1.157a7 7 0 0 1-.52-.455l.456-.471q.223.216.468.409zm-1.28-1.303a7 7 0 0 1-.403-.565l.558-.345s.132.213.36.506z",
    fill: "#A9AFC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.398 11.168h1.945v.656h-1.945zm-.652-1.755 1.375-1.375.464.464-1.375 1.375zm.121 4.124.464-.464 1.375 1.375-.464.464z",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 28.313H45.1V51.23H9.124z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.102 31.157v5.728a4.266 4.266 0 0 1-5.452-4.097 4.267 4.267 0 1 1-8.525 0 4.266 4.266 0 0 1-8.526 0 4.266 4.266 0 0 1-8.525 0 4.266 4.266 0 0 1-4.949 4.208v-5.839z",
    fill: "url(#paint0_linear_9129_148466)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.113 40.717h5.069V51.23h-5.069z",
    fill: "#DEE1EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.18 40.717h5.068V51.23H27.18z",
    fill: "#DEE1EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.51 51.56h-5.725V40.388h5.725zm-5.069-.657h4.413v-9.858H22.44z",
    fill: "#5E6175"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.576 51.56h-5.724V40.388h5.724zm-5.068-.657h4.412v-9.858h-4.412z",
    fill: "#5E6175"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.68 40.03h5.561v5.561H12.68z",
    fill: "#A9AFC4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.824 45.59h7.278v1.399h-7.278z",
    fill: "#5E6175"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.984 40.03h5.562v5.561h-5.562z",
    fill: "#A9AFC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57 45.919h-6.218v-6.216h6.218zm-5.562-.656h4.905v-4.904h-4.905zm28.864.656h-6.216v-6.216h6.218zm-5.562-.656h4.906v-4.904h-4.904z",
    fill: "#5E6175"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.125 45.59h7.278v1.399h-7.278zM19.43 47.317h-7.934v-2.054h7.934zm-7.278-.657h6.622v-.741h-6.622z",
    fill: "#5E6175"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 47.317h-7.933v-2.054h7.934zm-7.277-.657h6.622v-.741h-6.622zm-29.68 4.242h42.679v.657H5.773z",
    fill: "#5E6175"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.428 51.56H8.797V27.983h36.63zm-35.975-.657h35.318V28.64H9.453z",
    fill: "#5E6175"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m22.657 28.884 1.628-7.038H19.36l-5.107 7.038z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.363 21.846h-6.05l-7.762 7.038h8.705z",
    fill: "#2C9424"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m39.471 28.884-5.105-7.038H29.44l1.628 7.038z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m48.175 28.884-7.42-7.038h-6.392l5.106 7.038zm-17.105 0-1.628-7.038h-5.154l-1.628 7.038z",
    fill: "#2C9424"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.66 28.884h-8.402l-.18.25v1.382a4.267 4.267 0 0 0 8.25 1.683c.203-.537.297-1.11.274-1.683v-1.383z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.813 34.781a4.266 4.266 0 0 0 4.266-4.265v-1.383l.18-.25H5.551v1.633a4.266 4.266 0 0 0 4.262 4.265",
    fill: "#2C9424"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.47 28.884h-8.407l.058.25v1.382a4.263 4.263 0 0 0 4.262 4.433 4.267 4.267 0 0 0 4.262-4.433v-1.383z",
    fill: "#F5F5F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 29.133v1.383a4.266 4.266 0 1 0 8.525 0v-1.632h-8.706zm-8.586-.249h-8.406l-.058.25v1.382a4.267 4.267 0 0 0 5.93 4.078 4.27 4.27 0 0 0 2.596-4.078v-1.383z",
    fill: "#2C9424"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M22.66 28.884h-8.402l-.18.25v1.382a4.267 4.267 0 0 0 8.25 1.683c.203-.537.297-1.11.274-1.683v-1.383z",
    fill: "url(#paint1_linear_9129_148466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M9.813 34.781a4.266 4.266 0 0 0 4.266-4.265v-1.383l.18-.25H5.551v1.633a4.266 4.266 0 0 0 4.262 4.265",
    fill: "url(#paint2_linear_9129_148466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M39.47 28.884h-8.407l.058.25v1.382a4.263 4.263 0 0 0 4.262 4.433 4.267 4.267 0 0 0 4.262-4.433v-1.383z",
    fill: "url(#paint3_linear_9129_148466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M39.65 29.133v1.383a4.266 4.266 0 1 0 8.525 0v-1.632h-8.706z",
    fill: "url(#paint4_linear_9129_148466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.064 28.884h-8.406l-.058.25v1.382a4.267 4.267 0 0 0 5.93 4.078 4.27 4.27 0 0 0 2.596-4.078v-1.383z",
    fill: "url(#paint5_linear_9129_148466)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.34 35.11a4.594 4.594 0 0 1-4.594-4.594v-1.49l5.447-7.508H24.7l-1.77 7.656v1.342a4.594 4.594 0 0 1-4.59 4.594m-3.938-5.87v1.276a3.938 3.938 0 1 0 7.869 0v-1.422l1.601-6.922h-4.341z",
    fill: "#5E6175"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.813 35.11a4.594 4.594 0 0 1-4.594-4.594v-1.777l.11-.098 7.857-7.123h6.818l-5.601 7.721v1.277a4.594 4.594 0 0 1-4.59 4.594m-3.938-6.08v1.486a3.937 3.937 0 1 0 7.875 0v-1.49l4.97-6.852h-5.28zm29.513 6.079a4.594 4.594 0 0 1-4.594-4.594V29.17l-1.77-7.656h5.504l5.447 7.508v1.493a4.594 4.594 0 0 1-4.587 4.594m-5.535-12.936 1.6 6.92v1.422a3.936 3.936 0 0 0 6.775 2.888 3.94 3.94 0 0 0 1.094-2.888V29.24l-5.125-7.066z",
    fill: "#5E6175"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.914 35.11a4.594 4.594 0 0 1-4.594-4.594V29.24l-5.601-7.722h7.164l7.619 7.225v1.773a4.594 4.594 0 0 1-4.588 4.594m-8.906-12.936 4.971 6.852v1.49a3.937 3.937 0 1 0 7.87 0v-1.49l-7.219-6.852zm-8.145 12.935a4.594 4.594 0 0 1-4.593-4.594v-1.422l1.75-7.578h5.676l1.75 7.578v1.422a4.594 4.594 0 0 1-4.583 4.594m-3.937-5.94v1.346a3.937 3.937 0 1 0 7.87 0V29.17l-1.62-7h-4.628z",
    fill: "#5E6175"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.863 19.808a7.52 7.52 0 1 0 0-15.04 7.52 7.52 0 0 0 0 15.04",
    fill: "url(#paint6_linear_9129_148466)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.863 20.135a7.848 7.848 0 1 1 7.848-7.847 7.856 7.856 0 0 1-7.848 7.847m0-15.038a7.191 7.191 0 1 0 7.192 7.191 7.2 7.2 0 0 0-7.192-7.191",
    fill: "#5E6175"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.92 11.474h-2.983v1.98c0 .863.113 1.723.335 2.558l.163.609a.755.755 0 0 0 .736.553h2.617a.756.756 0 0 0 .736-.553l.163-.61a10 10 0 0 0 .334-2.558v-1.98z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.021 12.813v.64c0 .863-.112 1.723-.334 2.558l-.163.614a.76.76 0 0 1-.738.553h-2.615a.756.756 0 0 1-.736-.553l-.163-.61a10 10 0 0 1-.334-2.562v-.643c0 .864.112 1.723.334 2.558l.163.609a.76.76 0 0 0 .736.555h2.615a.76.76 0 0 0 .738-.555l.163-.61a10 10 0 0 0 .334-2.554",
    fill: "url(#paint7_linear_9129_148466)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.023 12.18v-.706h.516a1.737 1.737 0 0 1 1.763 1.71 1.68 1.68 0 0 1-.516 1.208 1.8 1.8 0 0 1-1.247.5h-.621q.048-.327.074-.655",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.788 17.5H25.17a1.084 1.084 0 0 1-1.053-.797l-.165-.605a10.3 10.3 0 0 1-.344-2.645v-2.307h5.74v2.307c0 .892-.116 1.78-.345 2.643l-.163.609a1.085 1.085 0 0 1-1.053.795m-3.522-5.703v1.656a9.6 9.6 0 0 0 .328 2.474l.163.61a.43.43 0 0 0 .419.31h2.616a.43.43 0 0 0 .419-.31l.163-.61a9.7 9.7 0 0 0 .328-2.474v-1.651z",
    fill: "#5E6175"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54 15.221h-1l.055-.376q.046-.317.07-.631l.657.051q-.012.15-.028.3h.248c.38.002.745-.145 1.018-.408a1.35 1.35 0 0 0 .417-.974 1.41 1.41 0 0 0-1.435-1.381h-.188v.378h-.656v-1.034h.844a2.067 2.067 0 0 1 2.091 2.037 2 2 0 0 1-.617 1.444 2.1 2.1 0 0 1-1.476.594m-3.965-4.764a1.544 1.544 0 0 1 0-2.188.89.89 0 0 0 0-1.256l.465-.464a1.55 1.55 0 0 1 0 2.187.886.886 0 0 0 0 1.256zm1.65 0a1.54 1.54 0 0 1 0-2.187l.463.463a.89.89 0 0 0 0 1.256zm10.908 11.695H15.871v-2.65h22.262zm-21.606-.656h20.95v-1.338h-20.95z",
    fill: "#5E6175"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 19.83h21.605v1.994H16.2zm9.753 25.816h2.492v.656h-2.492z",
    fill: "#5E6175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_148466",
    x1: 27.115,
    y1: 30.707,
    x2: 27.115,
    y2: 42.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9129_148466",
    x1: 18.368,
    y1: 28.433,
    x2: 18.368,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9129_148466",
    x1: 9.904,
    y1: 28.433,
    x2: 9.904,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9129_148466",
    x1: 35.359,
    y1: 28.433,
    x2: 35.359,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9129_148466",
    x1: 43.822,
    y1: 28.433,
    x2: 43.822,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9129_148466",
    x1: 26.863,
    y1: 28.433,
    x2: 26.863,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9129_148466",
    x1: 19.345,
    y1: 12.288,
    x2: 34.383,
    y2: 12.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9129_148466",
    x1: 26.479,
    y1: 14.556,
    x2: 26.479,
    y2: 18.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBusiness);
export default __webpack_public_path__ + "static/media/small-business.0e8215bb91b4ff12677e926129f3ade3.svg";
export { ForwardRef as ReactComponent };